export const InstantPaymentsName = {
  wechat: "am_weChat.png",
  alipay: "am_alipay.png",
  payconiq: "am_payconiq.png",
};
